import * as PIXI from "pixi.js";
import { EnumEventBus, EventBus } from "../../managers/EventBus";
import { BarBGBounds } from "../../types/Interface";
import TextureManager from "../../managers/TextureManager";
import { BetAmountStatus } from "../../types/Enum";
import { PAYAMOUNTLIST } from "../../types/Config";

const PAYAMOUNTBG = "./images/scene/pay_amount.png";

export default class PayAmount extends PIXI.Container {
  private Bounds: BarBGBounds;
  private payAmountList = PAYAMOUNTLIST;
  private index: number = 1;
  private amountText: PIXI.Text;
  private EventBus = EventBus;

  constructor(Bounds: BarBGBounds) {
    super();
    this.Bounds = Bounds;
    this.x = Bounds.x;
    this.y = Bounds.y;
    this.addBg();
    this.addAmount();
    this.EventBus.on(EnumEventBus.increaseAmount, () => this.setIndex(1));
    this.EventBus.on(EnumEventBus.decreaseAmount, () => this.setIndex(-1));
    this.EventBus.on(EnumEventBus.requestAmount, () => this.getAmount())
  }
  addBg() {
    const texture = TextureManager.getTexture(PAYAMOUNTBG);
    const bg = new PIXI.Sprite(texture);
    bg.width = this.Bounds.width;
    bg.height = this.Bounds.height;
    bg.anchor.set(.5);
    this.addChild(bg);
  }
  addAmount() {
    const style = { fill: 0xFFFFFF, fontSize: this.Bounds.fontSize }
    this.amountText = new PIXI.Text({ text: "", style })
    this.amountText.anchor.set(.5);
    this.amountText.x = 0;
    this.amountText.y = 17;
    this.amountText.style.fontWeight = "700"
    this.addChild(this.amountText);
    this.setAmount();
  }
  setIndex(v: number) {
    if (this.index > 0 && v < 0) {
      this.index -= 1;
    } else if (this.index < this.payAmountList.length - 1 && v > 0) {
      this.index += 1;
    }
    if (this.index == 0 && v < 0) {
      this.EventBus.emit(EnumEventBus.betAmountStatus, BetAmountStatus.min)
    } else if (this.index == this.payAmountList.length - 1 && v > 0) {
      this.EventBus.emit(EnumEventBus.betAmountStatus, BetAmountStatus.max)
    } else {
      this.EventBus.emit(EnumEventBus.betAmountStatus, BetAmountStatus.nonExtreme)
    }


    this.setAmount();

  }
  getAmount() {
    const amount = this.payAmountList[this.index];
    this.EventBus.emit(EnumEventBus.getAmount, amount);
  }
  setAmount() {
    const amount = `$${this.payAmountList[this.index]}`
    this.amountText.text = amount;
  }
}